module.exports = __webpack_public_path__ + "img/zlcg-bg.91de5250.png";